import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import mixins from './mixins'
import directives from './directives'

Vue.config.productionTip = false

// Register mixins
Vue.mixin(mixins)

// Register directives
Object.entries(directives).forEach(([key, value]) => {
  Vue.directive(key, value)
})

function createApp() {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

store.dispatch('auth/checkAuth').then(() => {
  createApp()
})
